import logo from './logo.svg';
import './App.css';
import { Routes, Route } from 'react-router-dom'

import Missing from './pages/Missing'
import Layout from './pages/Layout'
import HomePage from './pages/HomePage'
import Dashboard from './pages/Dashboard'
import ModalMakePaymentForClientPlotsForm from './pages/ModalMakePaymentForClientPlotsForm'
import ModalMakePaymentForClientRentalsForm from './pages/ModalMakePaymentForClientRentalsForm'
import ModalCreateCompanyForm from './pages/ModalCreateCompanyForm'
import ModalCreateBusinessLocationForm from './pages/ModalCreateBusinessLocationForm'
import ModalUploadPlotsForm from './pages/ModalUploadPlotsForm'
import ModalUploadHousesForm from './pages/ModalUploadHousesForm'
import ModalUploadUsersForm from './pages/ModalUploadUsersForm'
import ModalUploadPlotsCustomersForm from './pages/ModalUploadPlotsCustomersForm'
import ModalUploadTenantsForm from './pages/ModalUploadTenantsForm'
import ModalCreateExpenseForm from './pages/ModalCreateExpenseForm'
import ModalUploadRentalsExpenseForm from './pages/ModalUploadRentalsExpenseForm'
import ModalUploadPlotsExpenseForm from './pages/ModalUploadPlotsExpenseForm'
import ModalViewPlotsCustomers from './pages/ModalViewPlotsCustomers'
import ModalViewTenants from './pages/ModalViewTenants'
import ModalViewPlots from './pages/ModalViewPlots'
import ModalViewHouses from './pages/ModalViewHouses'
import ForgotPassword from './pages/ForgotPassword'
import ModalViewPlotsCustomersNHEF from './pages/ModalViewPlotsCustomersNHEF'
import ModalViewPlotsCustomersCurrentPayers from './pages/ModalViewPlotsCustomersCurrentPayers'
import ModalViewPlotsCustomersLatePayers from './pages/ModalViewPlotsCustomersLatePayers'
import ModalViewPlotsCustomersCompletedPayers from './pages/ModalViewPlotsCustomersCompletedPayers'
import ModalViewSoldAndUnsoldPlots from './pages/ModalViewSoldAndUnsoldPlots'
import ModalPlotsCustomers from './pages/ModalPlotsCustomers'

function App () {
  return (
    <Routes>
      <Route>
        <Route path='*' element={<Missing />} />
        <Route path='/' element={<HomePage />} />
        <Route path='/Dashboard' element={<Dashboard />} />
        <Route path='/ForgotPassword' element={<ForgotPassword />} />
        <Route path='/MakePaymentForClientPlotsForm' element={<ModalMakePaymentForClientPlotsForm />} />
        <Route path='/MakePaymentForClientRentalsForm' element={<ModalMakePaymentForClientRentalsForm />} />
        <Route path='/CreateCompanyForm' element={<ModalCreateCompanyForm />} />
        <Route path='/CreateBusinessLocationForm' element={<ModalCreateBusinessLocationForm />} />
        <Route path='/UploadPlotsForm' element={<ModalUploadPlotsForm />} />
        <Route path='/UploadHousesForm' element={<ModalUploadHousesForm />} />
        <Route path='/UploadUsersForm' element={<ModalUploadUsersForm />} />
        <Route path='/UploadPlotsCustomersForm' element={<ModalUploadPlotsCustomersForm />} />
        <Route path='/UploadTenantsForm' element={<ModalUploadTenantsForm />} />
        <Route path='/CreateExpenseForm' element={<ModalCreateExpenseForm />} />
        <Route path='/UploadRentalsExpenseForm' element={<ModalUploadRentalsExpenseForm />} />
        <Route path='/UploadPlotsExpenseForm' element={<ModalUploadPlotsExpenseForm />} />
        <Route path='/ViewPlotsCustomers' element={<ModalViewPlotsCustomers />} />
        <Route path='/ViewTenants' element={<ModalViewTenants />} />
        <Route path='/ViewPlots' element={<ModalViewPlots />} />
        <Route path='/ViewHouses' element={<ModalViewHouses />} />
        <Route path='/ViewPlotsCustomersNHEF' element={<ModalViewPlotsCustomersNHEF />} />
        <Route path='/ViewPlotsCustomersUptodatePayers' element={<ModalViewPlotsCustomersCurrentPayers />} />
        <Route path='/ViewPlotsCustomersLatePayers' element={<ModalViewPlotsCustomersLatePayers />} />
        <Route path='/ViewPlotsCustomersCompletedPayers' element={<ModalViewPlotsCustomersCompletedPayers />} />
        <Route path='/ViewSoldAndUnsoldPlots' element={<ModalViewSoldAndUnsoldPlots />} />
        <Route path='/PlotsCustomers' element={<ModalPlotsCustomers />} />
      </Route>
    </Routes>
  )
}

export default App;
